import { createRequestActionTypes } from '../../helpers'

export const FETCH_HEADER_DATA = createRequestActionTypes('HEADER', 'FETCH_HEADER_DATA')



// WEBPACK FOOTER //
// ./src/containers/Header/constants.js